<template>
  <svg viewBox="0 0 1000 200" class="rating">
    <defs>
      <polygon id="star" points="75,0 98,50 150,60 113,90 120,140 75,115 30,140 37,90 0,60 52,50"/>
      <clipPath id="stars">
        <use xlink:href="#star" x="0%"/>
        <use xlink:href="#star" x="21%"/>
        <use xlink:href="#star" x="42%"/>
        <use xlink:href="#star" x="63%"/>
        <use xlink:href="#star" x="84%"/>
      </clipPath>
    </defs>

    <rect class="rating-background" clip-path="url(#stars)"></rect>
    <rect :width="ratingWidth" class="rating-value" clip-path="url(#stars)"></rect>
  </svg>
</template>

<script>
export default {
  name: 'Rating',
  props: {
    rating: {
      type: String,
      default: '0',
      validator(value) {
        const number = parseFloat(value);
        return !isNaN(number) && number >= 0 && number <= 5;
      }
    }
  },
  computed: {
    ratingWidth() {
      const ratingNumber = parseFloat(this.rating);
      const percentage = (ratingNumber / 5) * 100;

      return `${percentage}%`;
    }
  }
}
</script>

<style scoped lang="scss">
.rating {
  width: 100%;

  .rating-background {
    fill: #CCCCCC;
    stroke: #F4C500;
    stroke-width: 4;
    height: 100%;
    width: 100%;
  }

  .rating-value {
    fill: #F4C500;
    height: 100%;
  }
}
</style>
